import { useState } from "react";
import {
  TextField,
  IconButton,
  Dialog,
  Typography,
  Box,
  Tooltip,
  Container,
  Stack,
  Button,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";

import conf from "config-dlm";
import SectionHeader from "components/utils/SectionHeader";
import { useUserServiceEditDescription } from "hooks/user/projects";
import { usePavmApplianceEditDescription } from "hooks/pavm/base";

type DescriptionWithEditProps = {
  id: string;
  type: "project" | "appliance";
  isAdmin: boolean;
  description: string;
};
const DescriptionWithEdit = (props: DescriptionWithEditProps) => {
  const { id, type, isAdmin, description } = props;

  const project = useUserServiceEditDescription();
  const appliance = usePavmApplianceEditDescription();

  const [current, setCurrent] = useState(description);
  const [updated, setUpdated] = useState(current);
  const [isEditing, setIsEditing] = useState(false);

  const handleOpen = () => setIsEditing(true);
  const handleClose = () => setIsEditing(false);

  const handleSave = () => {
    if (type === "project") {
      project.mutate({ id, description: updated });
    } else if (type === "appliance") {
      appliance.mutate({ id, description: updated });
    }

    setCurrent(updated); // save updated description
    setIsEditing(false);
  };

  return (
    <>
      {/* Description and Edit Button */}
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="caption" gutterBottom sx={{ display: "block" }}>
          {current}
        </Typography>

        {isAdmin && (
          <Tooltip title="Edit description">
            <IconButton onClick={handleOpen} color="inherit">
              <EditIcon sx={{ fontSize: 15 }} />
            </IconButton>
          </Tooltip>
        )}
      </Box>

      {/* Edit Modal */}
      <Dialog fullWidth maxWidth="md" open={isEditing} onClose={handleClose}>
        <Container component="main" sx={conf.STYLE.DIALOG}>
          <SectionHeader
            title="Edit description"
            icon={<EditIcon />}
            buttons={[
              <Button
                key="exit-desc"
                variant="outlined"
                color="inherit"
                onClick={handleClose}
              >
                <CloseIcon />
              </Button>,
            ]}
          />

          <TextField
            multiline
            fullWidth
            value={updated}
            variant="outlined"
            onChange={(e) => setUpdated(e.target.value)}
          />

          <Stack
            spacing={2}
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
            sx={{ mt: 2 }}
          >
            <Button variant="contained" onClick={handleSave}>
              Save
            </Button>
          </Stack>
        </Container>
      </Dialog>
    </>
  );
};

export default DescriptionWithEdit;
